import React from "react";
import clsx from "clsx";

import { ButtonProps } from "../button.types";

export const Button: React.FC<ButtonProps> = ({
  className,
  type,
  color = "primary",
  rounded = false,
  size = "md",
  buttonStyle = "default",
  onClick,
  children,
  disabled = false,
  transparent = false,
  ...props
}) => (
  <button
    className={clsx(
      "button",
      {
        [`button__${size}`]: size,
        [`button__${color}`]: color,
        [`button__${color}-${buttonStyle}`]: buttonStyle,
        [`button__transparent`]: transparent,
        button__rounded: rounded,
      },
      className
    )}
    type={type}
    onClick={onClick}
    disabled={disabled}
    {...props}
  >
    {children}
  </button>
);
